import { Fire } from '@phosphor-icons/react';
import { Wildfire } from './Wildfire';

import { HookObject, ListItemsHooks } from "@/plugins/types";
import { Dashboard } from "./Dashboard";

export const onListItems = (hook: HookObject, _, __, { permissions = [] }) => {
  if (hook.id === ListItemsHooks.APP_DRAWER && hook.position === "top") {
    if (!permissions.includes("wildfire")) return [];
    return [
      {
        label: "Wildfire",
        icon: <Fire className="text-lg" />,
        href: "/wildfire",
      },
    ];
  }

  if (hook.id === ListItemsHooks.ROUTES) {
    if (!permissions.includes("wildfire")) return [];
    return [
      {
        path: "/wildfire",
        element: <Wildfire name="Wildfire" />,
        children: [
          {
            path: ":id",
            element: <Dashboard name="Wildfire" />,
          },
        ],
      },
    ];
  }
};


export { Wildfire };